import { render, staticRenderFns } from "./itemsRevenueByClient.vue?vue&type=template&id=13adcb24&scoped=true&"
import script from "./itemsRevenueByClient.vue?vue&type=script&lang=js&"
export * from "./itemsRevenueByClient.vue?vue&type=script&lang=js&"
import style0 from "./itemsRevenueByClient.vue?vue&type=style&index=0&id=13adcb24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13adcb24",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VDataTable,VSelect})
